import script from "./MenuMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuMobile.vue?vue&type=script&setup=true&lang=js"

import "./MenuMobile.vue?vue&type=style&index=0&id=bfa56f42&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfa56f42"]])

export default __exports__